import { render } from "./CheckReplacement.vue?vue&type=template&id=1cf8999e&ts=true"
import script from "./CheckReplacement.vue?vue&type=script&lang=ts"
export * from "./CheckReplacement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__